module.exports = __webpack_public_path__ + "static/shopping-list-c7604eafe65fe2ede26124dd074f527f.jpeg";